import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
    createStyles({
        tableContainer: {
            maxHeight: 'calc(100vh - 310px)',
        },
        buttonStyle: {
            maxWidth: '180px',
            maxHeight: '35px',
            minWidth: '180px',
            minHeight: '35px',
            marginBottom: '8px',
        },
        tableHeader: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            borderCollapse: `collapse`,
        },
        tableTd: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            borderStyle: 'solid',
            padding: '0px',
        },
        colTime: {
            textAlign: 'center',
        },
        tableItem: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            orderBottomStyle: 'inset',
            borderLeftStyle: 'solid',
            borderRightStyle: 'solid',
            textAlign: 'center',
            minWidth: '80px',
            height: '8px',
            padding: '1px',
        },
        tableItemL: {
            borderWidth: '1px',
            borderColor: '#dcdcdc',
            orderBottomStyle: 'inset',
            borderLeftStyle: 'solid',
            borderRightStyle: 'solid',
            textAlign: 'left',
            minWidth: '80px',
            height: '8px',
            padding: '1px',
        },
        //テキスト
        textField: {
            flexGrow: 1,
            height: '100%',
            width: '98%',
            border: 'none',
        },
    })
);